export const zenodo = "https://zenodo.org/records/23298207";
export const github = "https://github.com/Ekanshthegreat";
export const linkedin = "https://ca.linkedin.com/in/ekansh-chawla-80a3b2218";
export const paper = `${zenodo}/files/rebalancing-paper-v1.0.0.pdf?download=1`;
export const code = `${zenodo}/files/rebalancing-code-results-v1.0.0.zip?download=1`;

export const stateValidityZenodo = "https://zenodo.org/records/23328001";
export const stateValidityDoi = "https://doi.org/10.5281/zenodo.23328001";
export const stateValidityPaper = `${stateValidityZenodo}/files/state_validity_report.pdf?download=1`;
export const stateValidityCode = `${stateValidityZenodo}/files/state-validity-research-v1.0.1.zip?download=1`;
export const stateValidityLatex = "/research/state-validity/state-validity-overleaf-v1.0.1.zip";
